import { Injectable } from '@angular/core';
import { psegLoadsTbl } from '../Models/LoadsData';
import { MinMaxDate } from '../Models/MiscModels';
import { GoogleChartService } from './google-chart.service';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
   google: any;
   private ChartTable;
  constructor(private gChartService: GoogleChartService) { }
  public GetMinMaxdate(chartData: Array<any>) {
    const minmaxDate: MinMaxDate = new MinMaxDate();

    minmaxDate.MinDate = new Date(chartData[0][0]);
    minmaxDate.MaxDate = new Date(chartData[chartData.length - 1][0]);
    return minmaxDate;
  }
  public  removeRowsInstLoad(dtTable: any, data: Array<any>): String {

    this.google = this.gChartService.getGoogle();

    data.sort((a, b) => (new Date(a.evaluatedAt)).valueOf() - (new Date(b.evaluatedAt)).valueOf());
    const maxEvalAt: Date  = new Date(data[data.length - 1].evaluatedAt);

  this.removeRowsLoad(dtTable, data); 

  const evalTimeStr = maxEvalAt.toLocaleString() + ' (EST)';
  return evalTimeStr;

}
public  removeRowsHrlyLoad(dtTable: any, data: Array<any>): String {

  this.google = this.gChartService.getGoogle();

  const maxEvalAt = new Date(data[0].timestamp);
  const evalTimeStr = maxEvalAt.toLocaleString() + ' (EST)';
  data.splice(0, 1);

  this.removeRowsLoad(dtTable, data); 

  return evalTimeStr;

}
  public compareDate(date1: Date, date2: Date): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    const d1 = new Date(date1); const d2 = new Date(date2);

    return d1.valueOf() - d2.valueOf();
  }
  public  removeRowsLoad(dtTable: any, data: Array<any>) {

    this.google = this.gChartService.getGoogle();

    data.sort((a, b) => a.timestamp.valueOf() - b.timestamp.valueOf());
    const minTimestamp: Date = new Date(data[0].timestamp);

    for (let i = dtTable.getNumberOfRows() - 1; i >= 0; i--) {
      const rowDate: Date  = new Date(dtTable.getValue(i, 0));
      if (this.compareDate(rowDate, minTimestamp) >= 0) {
        dtTable.removeRow(i);
      } else {
        break;
      }
    }
    return;
  }

}

